/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import DiscountCode from "views/DiscountCode";
import EditUserInfo from "views/EditUserInfo";
import Email from "views/Email";
import FoodList from "views/FoodList";
import GetUser from "views/GetUser";

import Login from "views/login";
import Map from "views/Map.js";
import MotivationalTips from "views/MotivationalTips";
import Notifications from "views/Notifications.js";
import Reservations from "views/Reservations";
import ReservationsSystemManagement from "views/ReservationsSystemManagement";
import Rtl from "views/Rtl.js";
import TicketMessages from "views/TicketMessages";
import Tickets from "views/Tickets";
import TicketsCounseling from "views/TicketsCounseling";
// import TableList from "views/TableList.js";
import Typography from "views/Typography.js";
import UserProfile from "views/UserProfile.js";
import UsersListInfo from "views/UsersListInfo";

var routes = [
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   rtlName: "لوحة القيادة",
  //   icon: "tim-icons icon-chart-pie-36",
  //   component: <Dashboard />,
  //   layout: "/admin", icon-bullet-list-67
  // },
  {
    path: "/rtl-dashboard",
    name: "داشبورد",
    rtlName: "داشبورد",
    icon: "tim-icons icon-chart-pie-36",
    component: <Dashboard />,
    layout: "/rtl",
  },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   rtlName: "الرموز",
  //   icon: "tim-icons icon-atom",
  //   component: <Icons />,
  //   layout: "/admin",
  // },
  {
    path: "/rtl-users-list",
    name: "لیست کاربران",
    rtlName: "لیست کاربران",
    icon: "tim-icons icon-bullet-list-67",
    component: <UsersListInfo />,
    layout: "/rtl",
  },
  {
    path: "/rtl-reservations-system-management",
    name: "مدیریت سیستم رزرو",
    rtlName: "مدیریت سیستم رزرو",
    icon: "tim-icons icon-bullet-list-67",
    component: <ReservationsSystemManagement />,
    layout: "/rtl",
  },
  {
    path: "/rtl-reservations",
    name: "رزرو های مشاوره",
    rtlName: "رزرو های مشاوره",
    icon: "tim-icons icon-bullet-list-67",
    component: <Reservations />,
    layout: "/rtl",
  },
  {
    path: "/rtl-tickets",
    name: "صندوق پیام رژیم",
    rtlName: "صندوق پیام رژیم",
    icon: "tim-icons icon-bullet-list-67",
    component: <Tickets />,
    layout: "/rtl",
  },
  {
    path: "/rtl-tickets-counseling",
    name: "صندوق پیام مشاوره",
    rtlName: "صندوق پیام مشاوره",
    icon: "tim-icons icon-bullet-list-67",
    component: <TicketsCounseling />,
    layout: "/rtl",
  },
  {
    path: "/rtl-food-list",
    name: "لیست غذایی",
    rtlName: "لیست غذایی",
    icon: "tim-icons icon-bullet-list-67",
    component: <FoodList />,
    layout: "/rtl",
  },
  {
    path: "/rtl-discount-code",
    name: "کد تخفیف",
    rtlName: "کد تخفیف",
    icon: "tim-icons icon-bullet-list-67",
    component: <DiscountCode />,
    layout: "/rtl",
  },
  {
    path: "/rtl-email",
    name: "ایمیل",
    rtlName: "ایمیل",
    icon: "tim-icons icon-bullet-list-67",
    component: <Email />,
    layout: "/rtl",
  },

  {
    path: "/rtl-motivational-tips",
    name: "نکات انگیزشی",
    rtlName: "نکات انگیزشی",
    icon: "tim-icons icon-bullet-list-67",
    component: <MotivationalTips />,
    layout: "/rtl",
  },
  
  {
    path: "/rtl-ticket-messages",
    name: "صفحه پیام",
    rtlName: "صفحه پیام",
    icon: "tim-icons icon-bullet-list-67",
    component: <TicketMessages />,
    layout: "/rtl",
  },
  
  
  {
    path: "/rtl-get-user-info",
    name: "اطلاعات کاربر",
    rtlName: "اطلاعات کاربر",
    icon: "tim-icons icon-bullet-list-67",
    component: <GetUser />,
    layout: "/rtl",
  },

  {
    path: "/rtl-edit-user-info",
    name: "ویرایش اطلاعات کاربر",
    rtlName: "ویرایش اطلاعات کاربر",
    icon: "tim-icons icon-bullet-list-67",
    component: <EditUserInfo/>,
    layout: "/rtl",
  },

  {
    path: "/map",
    name: "Map",
    rtlName: "خرائط",
    icon: "tim-icons icon-pin",
    component: <Map />,
    layout: "/admin",
  },
  {
    path: "/notifications",
    name: "Notifications",
    rtlName: "إخطارات",
    icon: "tim-icons icon-bell-55",
    component: <Notifications />,
    layout: "/admin",
  },
  {
    path: "/user-profile",
    name: "User Profile",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: <UserProfile />,
    layout: "/admin",
  },
  // {
  //   path: "/tables",
  //   name: "Table List",
  //   rtlName: "قائمة الجدول",
  //   icon: "tim-icons icon-puzzle-10",
  //   component: <TableList />,
  //   layout: "/admin",
  // },
  {
    path: "/typography",
    name: "Typography",
    rtlName: "طباعة",
    icon: "tim-icons icon-align-center",
    component: <Typography />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Typography",
    rtlName: "طباعة",
    icon: "tim-icons icon-align-center",
    component: <Login />,
    layout: "/rtl"

  },
  //----------------------rtl-------------------------
  {
    path: "/rtl-support",
    name: "RTL Support",
    rtlName: "ار تي ال",
    icon: "tim-icons icon-world",
    component: <Rtl />,
    layout: "/rtl",
  },
  // {
  //   path: "/rtl-dashboard",
  //   name: "RTL Support",
  //   rtlName: "ار تي ال",
  //   icon: "tim-icons icon-world",
  //   component: <Rtl />,
  //   layout: "/rtl",
  // },
  // {
  //   path: "/rtl-icons",
  //   name: "RTL Support",
  //   rtlName: "ار تي ال",
  //   icon: "tim-icons icon-world",
  //   component: <Rtl />,
  //   layout: "/rtl",
  // },
];
export default routes;
